<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <!--<router-link :to="{ name: 'top', params: {} }">-->
            <!--<i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>-->
          <!--</router-link>-->
          <b v-if="!isConfirm"><trans-text i18nKey="ui[95][1]"/></b>
          <b v-else><trans-text i18nKey="ui[95][14]"/></b>
        </h3>
      </div>
    </div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <p class=" questionnaire-subhead mb-0"><trans-text i18nKey="ui[95][2]"/></p>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">
          <!--<div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">-->
            <!--<b><trans-text :i18nKey="apiErrorI18nKey"/></b>-->
          <!--</div>-->
          <!-- 入力フォーム -->

          <page-form @tryForm="tryForm" :isConfirm="isConfirm" @toggleConfirm="toggleConfirm" @sendForm="sendForm"></page-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from 'page/partials/Order/DemoQuestionnaireOrderer/PageForm.vue'
  import Order from 'processor/Order'

  export default {
    name:"",
    components: {
      PageForm,
    },
    data () {
      return {
        isConfirm:false,
          input:{},
      }
    },
    created(){
    },
    methods:{
      toggleConfirm(){
        this.isConfirm=!this.isConfirm;
      },
      tryForm(input){
        this.input = input
        $("#ThanksDemoQuestionnaireAlert").modal({backdrop: 'static', keyboard: false})
      },
      sendForm(input){
        let order = store.session("order") || {}

        Order.updateOrdererQuestionnaireAnswer(Object.assign({},input,{"order_id":order.id}))
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            this.$router.push({name:"payment::complete"})
          })
      },
    }
  }
</script>


<style lang="scss" scoped>
  .questionnaire-subhead{
    font-size: .8rem;
  }

</style>



// WEBPACK FOOTER //
// DemoQuestionnaireOrderer.vue?3fa9eaca